import { Box, Typography } from '@mui/material';
import { Business, Category } from '@mui/icons-material';
import React from 'react';
import InfoRow from './InfoRow';

import { companySizes } from '../../constants';

interface EconomicSectionProps {
  economicSector: string | null;
  economicSubSector: string | null;
  economicActivity: string | null;
  salesSegment: string | null;
}

const EconomicSection: React.FC<EconomicSectionProps> = ({
  economicSector,
  economicSubSector,
  economicActivity,
  salesSegment,
}) => {
  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
      <Box
        sx={{
          backgroundColor: 'rgba(76, 175, 80, 0.08)',
          borderRadius: '8px',
          px: 1.5,
          py: 0.8,
          border: '1px solid rgba(76, 175, 80, 0.15)',
        }}
      >
        <Typography
          variant="subtitle2"
          sx={{
            fontWeight: 600,
            color: 'success.main',
            fontSize: '0.75rem',
            textTransform: 'uppercase',
            letterSpacing: '0.5px',
            textAlign: 'center',
          }}
        >
          Clasificación Económica
        </Typography>
      </Box>
      <InfoRow
        label="Sector Económico"
        value={economicSector}
        maxLength={40}
        icon={<Category sx={{ fontSize: '0.8rem', color: 'success.main' }} />}
      />
      <InfoRow
        label="Subsector Económico"
        value={economicSubSector}
        maxLength={40}
        icon={<Category sx={{ fontSize: '0.8rem', color: 'success.main' }} />}
      />
      <InfoRow
        label="Actividad Económica"
        value={economicActivity}
        maxLength={40}
        icon={<Category sx={{ fontSize: '0.8rem', color: 'success.main' }} />}
      />
      <InfoRow
        label="Segmento de Ventas"
        value={`${salesSegment} (Tramo ${
          companySizes.find((size) => size.name === salesSegment)?.id ??
          'No disponible'
        })`}
        maxLength={40}
        icon={<Business sx={{ fontSize: '0.8rem', color: 'success.main' }} />}
      />
    </Box>
  );
};

export default EconomicSection;
